import React from 'react'
import useAccordionPanelStyles from './accordion-panel.styles'
import { Accordion, AccordionSummary, AccordionDetails, Typography  } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

interface AccordionPanelProps {
    panelName: String;
    panelFields: any;
    panelDescription?: any;
    expanded?: boolean;
    onChange?: any;
    index?: number;
    status?: any;
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({ 
    panelName, 
    panelDescription,
    panelFields, 
    onChange, 
    index, 
    expanded=true, 
    status 
}) => {
    const classes = useAccordionPanelStyles();

    const handleChange = (panelIndex) => (event, isExpanded) => {
        onChange(panelIndex, isExpanded);
    };

    const  getAccordionProps = () => {
        const accordionProps = {
            className: classes.accordionPanel
        }

        if(onChange) {
            accordionProps['expanded'] = expanded;
            accordionProps['onChange'] = handleChange(index);
        } else {
            accordionProps['defaultExpanded'] = true;
        }

        return accordionProps;
    }
    
    return (
        <div>
            <Accordion {...getAccordionProps()}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h1">{panelName}</Typography>
                    {!expanded && status } 
                </AccordionSummary>
                <AccordionDetails>
                    <div className={classes.accordionPanelBody}>
                        {panelDescription}
                        {panelFields}
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default AccordionPanel;